import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { createSelector } from 'reselect';

export const getAuthenticationConfig = (state: IStoreState) => state.authentication;
export const getUserPool = createSelector(
  getAuthenticationConfig,
  (authentication) => authentication.userPool as CognitoUserPool,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/helpers/authentication.ts